<!--
 * @Author: OnismYY
 * @Description: 个人账户中心
-->

<template>
  <v-navigation-drawer
    border="none"
    elevation="1"
    v-model="customizeTheme.mainSidebar"
    id="mainMenu"
    :touchless="false"
    location="right"
    temporary
  >
    <template v-slot:prepend>
      <v-card max-width="420">
        <v-list lines="three" density="compact">
          <v-list-item>
            <template v-slot:prepend>
              <v-avatar size="40">
                <v-img v-if="userStore.userInfo?.avatarUrl" :src="userStore.userInfo?.avatarUrl"></v-img>
                <v-img v-else src="@/assets/avatar/IDR_PROFILE_AVATAR_39@1x.png"></v-img>
              </v-avatar>
            </template>

            <v-list-item-title class="font-weight-bold text-primary">
              {{ userStore.userInfo?.nickName || '匿名' }}
              <status-menu />
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ userStore.userInfo?.phone }}
            </v-list-item-subtitle>

            <!-- 退出登录 -->
            <template v-slot:append>
              <v-btn color="grey-lighten-1" icon="mdi-logout" variant="text" class="ml-3" @click="handleLogout"></v-btn>
            </template>
          </v-list-item>
        </v-list>

        <v-divider />

        <!---下拉框切换基地操作 -->
        <bis-operate />

        <v-divider />

        <!---菜单列表 -->
        <main-menu :menu="navigation.menu"></main-menu>
      </v-card>
    </template>
    <template v-slot:append>
      <div class="pa-3">
        <language-switcher />
      </div>
      <div class="pa-3">
        <div class="text-center">版本号：v {{ version }}</div>
        <v-btn class="my-6" color="primary" block prepend-icon="mdi-swap-horizontal" variant="elevated" @click="openExternalWeb">
          切换易种OS v1
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { useBisStore } from '@/stores/bis.js'
import configs from '@/configs'
import { version } from '@/configs'

import { useCustomizeThemeStore } from '@/stores/customize-theme'

const customizeTheme = useCustomizeThemeStore()
const router = useRouter()
const userStore = useUserStore()
const navigation = ref(configs.navigation)

const handleLogout = () => {
  userStore.logout()
  useBisStore().logout()
  router.push({ name: 'login' })
}

const openExternalWeb = () => {
  window.open('https://h5.yigrow.cn', '_blank')
}
</script>

<style scoped lang="scss"></style>
